import React from 'react';
import PropTypes from 'prop-types';

/**
 * Adds ReponseTap Id for phone number tracking
 */
const ResponseTap = ({ rtId = '', children, className = '' }) => (
  <span className={`${rtId} ${className}`}>{children}</span>
);

ResponseTap.propTypes = {
  /** The ResponseTap tracking ID */
  rtId: PropTypes.string,
  children: PropTypes.any,
  className: PropTypes.string,
};

export default ResponseTap;
